document.querySelectorAll( '.whippet-product-gallery--many' ).forEach( widget => {
	widget.querySelectorAll( 'details' ).forEach( details => {
		details.querySelector( 'summary' ).addEventListener( 'click', event => {
			// Ensure at least one case study remains open
			if( details.open ) {
				event.preventDefault();
			}
		} );
	} );
} );
